<template>
    <v-container>
        <v-row no-gutters class="mb-5">
            <v-col cols="12">
                <v-card>
                    <v-container class="px-3 py-0" v-if="searchParams">
                        <v-row align="center">
                            <v-col>
                                <v-autocomplete
                                    label="Unit"
                                    item-value="id"
                                    item-text="number"
                                    :items="units"
                                    no-filter
                                    :loading="isSearchingUnit"
                                    :search-input.sync="unitSearch"
                                    v-model="searchParams.unitId"
                                    no-data-text="Start typing a Unit Name or Number"
                                    name="unit"
                                    autocomplete="off"
                                    hide-details
                                    :clearable="true"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.number }} ({{ item.garage }})</v-list-item-title>
                                            <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-select
                                    v-model="searchParams.garageLocationId"
                                    :items="garages"
                                    name="garage"
                                    label="Garage"
                                    item-value="id"
                                    item-text="location"
                                    hide-details
                                    :clearable="true"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="User"
                                    v-model="searchParams.user"
                                    name="user"
                                    :clearable="true"
                                    autocomplete="off"
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col>
                                <v-select
                                    v-model="searchParams.types"
                                    :items="types"
                                    label="Types"
                                    multiple
                                    chips
                                    deletable-chips
                                    item-value="id"
                                    item-text="name"
                                    hide-details
                                    :clearable="true"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col>
                                <v-menu
                                    v-model="startDateDialog"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            label="Start Date"
                                            readonly
                                            v-model="formattedStartDate"
                                            name="received date"
                                            v-on="on"
                                            append-icon="event"
                                            hide-details
                                            @click:append="startDateDialog = true"
                                            :clearable="true"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        no-title
                                        v-model="searchParams.from"
                                        @change="startDateDialog = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-menu
                                    v-model="endDateDialog"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="formattedEndDate"
                                            label="End Date"
                                            readonly
                                            name="end date"
                                            v-on="on"
                                            append-icon="event"
                                            hide-details
                                            @click:append="endDateDialog = true"
                                            :clearable="true"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        no-title
                                        v-model="searchParams.to"
                                        @change="endDateDialog = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col class="shrink">
                                <v-btn text icon @click.native="performSearch">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col class="shrink pr-0 pl-1">
                                <v-btn text icon @click.native="clearSearch">
                                    <v-icon>clear</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="mx-0 pb-3">
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn small tile v-on="on">
                        <v-icon>save_alt</v-icon>&nbsp;Export
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="exportCsv()">
                        <v-list-item-title>
                            <v-icon>grid_on</v-icon>&nbsp;Excel (CSV)
                            <v-chip x-small>limit {{maxRowsPerCsv}} rows</v-chip>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-row>
        <v-card>
            <v-data-table
                :items="audits"
                :items-per-page="options.itemsPerPage"
                :headers="headers"
                :loading="$wait.is(['loading audits'])"
                :footer-props.sync="footerProps"
                :options.sync="options"
                show-expand
                :expanded.sync="expanded"
                :server-items-length="serverCount"
                :multi-sort="false"
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:item="{item, isExpanded, expand}">
                    <tr>
                        <td>{{item.dateChanged | formatDateTime}}</td>
                        <td>{{item.action}}</td>
                        <td>{{entityName(item.entityName)}}</td>
                        <td>{{item.unitNumber}}</td>
                        <td>{{item.garage}}</td>
                        <td>{{item.username}}</td>
                        <td>
                            <v-btn @click="expand(true)" icon fab v-if="!isExpanded">
                                <v-icon>expand_more</v-icon>
                            </v-btn>
                            <v-btn @click="expand(false)" icon fab v-if="isExpanded">
                                <v-icon>expand_less</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-results>
                    <v-layout row align-center>
                        <v-flex>No matching records found</v-flex>
                    </v-layout>
                </template>
                <template v-slot:expanded-item="{ item, headers }">
                    <td :colspan="headers.length" class="pa-3">
                        <v-simple-table dark>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Field</th>
                                        <th class="text-left">Old Value</th>
                                        <th class="text-left">New Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="x in item.propertyChanges" :key="x.propertyName">
                                        <td>{{ x.propertyName }}</td>
                                        <td>{{ x.oldValue }}</td>
                                        <td>{{ x.newValue }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </td>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';
import Audits from './AuditingClient.vue';
import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';
import DownloadHelper from '@/lib/DownloadHelper';

export default {
    mixins: [Audits, GarageLocations],
    data() {
        return {
            maxRowsPerCsv: 500000,
            audits: [],
            serverCount: 0,
            units: [],
            isSearchingUnit: false,
            unitSearch: '',
            selectedUnit: null,
            search: '',
            startDateDialog: false,
            endDateDialog: false,
            auditViewDialog: false,
            selectedAudit: null,
            expanded: [],
            options: {
                itemsPerPage: 20,
                sortBy: ['dateChanged'],
                sortDesc: [true]
            },
            footerProps: {
                itemsPerPageOptions: [20, 100, 200]
            },
            headers: [
                { text: 'Date/Time Changed', value: 'dateChanged' },
                { text: 'Action', value: 'action', sortable: false },
                { text: 'Entity Type', value: 'entityName' },
                { text: 'Unit', value: 'unitNumber' },
                { text: 'Garage', value: 'garage' },
                { text: 'Username', value: 'username' },
                { text: '', value: 'data-table-expand', sortable: false }
            ],
            searchParams: null,
            types: []
        };
    },
    computed: {
        formattedStartDate: {
            get() {
                return this.searchParams.from ? moment(this.searchParams.from).format(DateFormat.DefaultDisplay) : '';
            },
            set() {
                //set when clearing
                this.searchParams.from = null;
            }
        },
        formattedEndDate: {
            get() {
                return this.searchParams.to ? moment(this.searchParams.to).format(DateFormat.DefaultDisplay) : '';
            },
            set() {
                //set when clearing
                this.searchParams.to = null;
            }
        }
    },
    methods: {
        async performSearch() {
            var results = await this.searchAudits(this.getSearchParams());
            this.audits = results ? results.data : [];
            this.serverCount = results ? results.total : 0;
        },
        getSearchParams() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;

            return {
                ...this.searchParams,
                page,
                pageSize: itemsPerPage,
                orderBy: sortBy.length ? sortBy[0] : null,
                orderByDescending: sortDesc.length ? sortDesc[0] : false
            };
        },
        async clearSearch() {
            this.resetSearch();
            await this.performSearch();
        },
        resetSearch() {
            this.searchParams = {
                unitId: '',
                garageLocationId: null,
                types: [],
                user: '',
                from: null,
                to: null
            };
        },
        performUnitSearch: _.debounce(async (val, me) => {
            if (!me.unitSearch) {
                me.unitSearch = me.selectedUnit ? me.selectedUnit.name : '';
            }
            if (!me.unitSearch) {
                return;
            }

            try {
                me.isSearchingUnit = true;
                const response = await me.$api.get(`units?searchTerm=${me.unitSearch}&unitType='both'&orderByUnitMatch=true`);
                me.units = response.data.data;
            } catch {
                me.$toast.error('There was an error getting units');
            }
            me.isSearchingUnit = false;
        }, 200),
        entityName(name) {
            let parts = name.split('.');
            return parts[parts.length - 1];
        },
        async exportCsv() {
            var searchParams = this.getSearchParams();
            searchParams.page = 1;
            searchParams.pageSize = this.maxRowsPerCsv;

            var data = await this.searchAudits(searchParams);

            const changeFrom = props => props.map(x => `${x.propertyName}:${x.oldValue || ''}`).join('|');
            const changeTo = props => props.map(x => `${x.propertyName}:${x.newValue || ''}`).join('|');

            var rows = [];
            for (let item of data.data) {
                rows.push([item.dateChanged, item.action, this.entityName(item.entityName), item.unitNumber, item.garage, item.username, changeFrom(item.propertyChanges), changeTo(item.propertyChanges)]);
            }

            var csv = DownloadHelper.makeCsv(['Date/Time Changed', 'Action', 'Entity Type', 'Unit', 'Garage', 'Username', 'Changed From', 'Changed To'], rows);
            DownloadHelper.download(`Audits_${moment().format(DateFormat.Canonical)}.csv`, new Blob([csv]));
        }
    },
    watch: {
        async unitSearch(val) {
            this.performUnitSearch(val, this);
        },
        options: {
            async handler() {
                await this.performSearch();
            },
            deep: true
        }
    },
    async mounted() {
        await this.getGarageSelections();
        this.types = await this.auditTypes();
        this.resetSearch();
        await this.performSearch();
    }
};
</script>


<style lang="scss" scoped>
.v-menu.v-menu--inline {
    display: inline !important;
}
</style>
